import type { IResourcesFetcher } from "../network/fetchers/ResourcesFetcher";
import type { Language } from "../util/language/language";
import sanitizeHtml from "sanitize-html";

export interface IResourcesStore {
    readonly resources: IResources;
    readonly currentLanguage: Language;
    readonly possibleLanguages: Language[];

    getResourceWithKey(key: string): string | null;

    setLanguage(language: string): void;
    
    getFormattedResource(key: string, params?: string[] | null): string;
}

export class ResourcesStore implements IResourcesStore {
    constructor(
        readonly resources: IResources,
        readonly currentLanguage: Language,
        readonly possibleLanguages: Language[],
        private readonly resourcesFetcher: IResourcesFetcher,
    ) {}

    getResourceWithKey(key: string): string | null {
        const { resources } = this;
        if (!resources) throw new Error(`Tried to fetch a resource with key ${key} but resources are not loaded yet...`);
        return resources[key] ?? null;
    }

    async setLanguage(language: string): Promise<void> {
        await this.resourcesFetcher.setLanguage(language);
        window.location.reload();
    }

    getFormattedResource(key: string, params?: string[] | null): string {
        const resource = this.getResourceWithKey(key);
        if (!resource) return key;

        return params
            ? resource.replace(/{(\d+)}/g, (match, number) => (sanitizeHtml(params[number]) ?? match))
            : resource;
    }
}
